import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../stores/useAuthStore';
import { useProfileStore } from '../../stores/useDataStore';

const ProfileSettingsModal = ({ isOpen, onClose }) => {
  const currentUser = useAuthStore((state) => state.currentUser);
  const profilesCache = useProfileStore((state) => state.profilesCache);
  const updatePrivacy = useProfileStore((state) => state.updatePrivacy);
  const profileData = currentUser?.username
    ? profilesCache[currentUser.username.toLowerCase()]?.profileData
    : null;

  const defaultPrivacy = {
    photos: 'public',
    clips: 'public',
    music: 'public',
    articles: 'public',
    profileVisibility: 'public',
  };

  const [localSettings, setLocalSettings] = useState(
    profileData?.privacy || defaultPrivacy
  );

  useEffect(() => {
    if (isOpen) {
      setLocalSettings(profileData?.privacy || defaultPrivacy);
    }
  }, [isOpen, profileData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalSettings((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    updatePrivacy(localSettings);
    onClose();
  };

  if (!isOpen) return null;

  const PrivacyOption = ({ label, name, value }) => (
    <div className="flex items-center justify-between py-3 border-b">
      <label htmlFor={name} className="font-semibold text-gray-700 text-sm">
        {label}
      </label>
      <select
        id={name}
        name={name}
        value={localSettings[name]}
        onChange={handleChange}
        className="border border-gray-300 rounded-md p-1 text-sm"
      >
        <option value="public">Público</option>
        <option value="friends_only">Solo Amigos</option>
        <option value="private">Privado</option>
      </select>
    </div>
  );

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-md w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold text-gray-800 mb-4">
          Configuración de Privacidad
        </h2>

        <PrivacyOption label="Fotos" name="photos" value={localSettings.photos} />
        <PrivacyOption label="Clips" name="clips" value={localSettings.clips} />
        <PrivacyOption label="Música" name="music" value={localSettings.music} />
        <PrivacyOption
          label="Artículos"
          name="articles"
          value={localSettings.articles}
        />

        <div className="mt-6 border-t pt-4">
          <h3 className="font-bold text-gray-800">Visibilidad del Perfil</h3>
          <p className="text-xs text-gray-500 mb-2">
            Controla quién puede ver tu perfil completo.
          </p>
          <PrivacyOption
            label="Perfil Completo"
            name="profileVisibility"
            value={localSettings.profileVisibility}
          />
        </div>

        <div className="flex justify-end space-x-2 pt-6">
          <button
            type="button"
            onClick={onClose}
            className="py-2 px-4 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
          >
            Cancelar
          </button>
          <button
            onClick={handleSave}
            className="py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileSettingsModal;
